import * as React from 'react';

const Bump24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m11.99 2.55 8 10.7h-4.06v4.98H8.06v-4.98H4.01l7.98-10.7Zm0-2.05c-.21 0-.41.09-.55.28l-9.6 12.87c-.34.45-.01 1.1.55 1.1h4.17v4.29c0 .38.31.69.69.69h9.5c.38 0 .69-.31.69-.69v-4.29h4.19c.56 0 .89-.64.55-1.1L12.54.78a.696.696 0 0 0-.55-.28Zm5.4 21.32H6.61v1.68h10.78v-1.68Z"
  }
));
Bump24.Size = 24;
Bump24.Title = "Bump";

export { Bump24 as default };
